import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { Map as ImmutableMap } from 'immutable';

export const DIALOG_TYPE_ASSET = 'ASSET_DIALOG';

export const showRealEstateDialog = (linkTo?: string) =>
  rootUiActions.createDialog(
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE_ASSET,
      id: DIALOG_TYPE_ASSET,
      allowNesting: true,
      props: ImmutableMap({
        assetType: 'realEstate',
        linkTo,
      }),
    }),
  );
export const showVehicleDialog = rootUiActions.createDialog(
  rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE_ASSET,
    id: DIALOG_TYPE_ASSET,
    allowNesting: true,
    props: ImmutableMap({
      assetType: 'vehicle',
    }),
  }),
);
